module.exports = __webpack_public_path__ + "static/media/Assets-04-AB-dental-hero.a6bc6d0b.jpg";